
export const generatePhotographyBusinessSchema = () => {
  return {
    "@context": "https://schema.org",
    "@type": "PhotographyBusiness",
    "name": "Czułe Klisze",
    "image": "https://czuleklisze.pl/lovable-uploads/9faee032-6192-4c8c-b85b-6cecf4858091.png",
    "logo": "https://czuleklisze.pl/favicon.svg",
    "url": "https://czuleklisze.pl",
    "telephone": "+48123456789",
    "email": "kontakt@czuleklisze.pl",
    "description": "Profesjonalne studio fotograficzne specjalizujące się w naturalnej fotografii i klasycznych filmach ślubnych. Tworzymy ponadczasowe wspomnienia z wyjątkowych chwil.",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "ul. Fotograficzna 123",
      "addressLocality": "Warszawa",
      "postalCode": "00-001",
      "addressCountry": "PL"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 52.2297,
      "longitude": 21.0122
    },
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "09:00",
        "closes": "17:00"
      }
    ],
    "priceRange": "$$",
    "sameAs": [
      "https://www.facebook.com/czuleklisze",
      "https://www.instagram.com/czuleklisze"
    ],
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Usługi fotograficzne",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Sesja ślubna",
            "description": "Profesjonalna fotografia ślubna"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Sesja portretowa",
            "description": "Naturalne portrety w studiu lub plenerze"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Film ślubny",
            "description": "Klasyczne filmy ślubne w kinowym stylu"
          }
        }
      ]
    }
  };
};

export const generateBlogPostingSchema = (post: {
  title: string;
  slug: string;
  date: string;
  author: string;
  excerpt: string;
  image?: string;
}) => {
  return {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": `https://czuleklisze.pl/blog/${post.slug}`
    },
    "headline": post.title,
    "image": post.image || "https://czuleklisze.pl/lovable-uploads/9faee032-6192-4c8c-b85b-6cecf4858091.png",
    "datePublished": post.date,
    "dateModified": post.date,
    "author": {
      "@type": "Person",
      "name": post.author
    },
    "publisher": {
      "@type": "Organization",
      "name": "Czułe Klisze",
      "logo": {
        "@type": "ImageObject",
        "url": "https://czuleklisze.pl/favicon.svg"
      }
    },
    "description": post.excerpt
  };
};

export const generateBreadcrumbSchema = (items: Array<{name: string, item: string}>) => {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map((breadcrumb, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": breadcrumb.name,
      "item": breadcrumb.item
    }))
  };
};

export const generateFAQSchema = (faqs: Array<{question: string, answer: string}>) => {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map(faq => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.answer
      }
    }))
  };
};
